// extracted by mini-css-extract-plugin
export default {"inboxNavLinks":"InboxNavLinks_inboxNavLinks__HMvnB","active":"InboxNavLinks_active__EFqWU"};